import { useEffect, useRef, useCallback } from 'react';
import { motion } from 'framer-motion';

export const ScrollProgress = () => {
  const progressRef = useRef(0);
  const barRef = useRef(null);

  const handleScroll = useCallback(() => {
    const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (totalHeight <= 0) return;
    const newProgress = (window.scrollY / totalHeight) * 100;
    progressRef.current = newProgress;
    if (barRef.current) {
      barRef.current.style.width = `${newProgress}%`;
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <div className="fixed top-0 left-0 right-0 h-1 z-[60] bg-border/20">
      <motion.div
        ref={barRef}
        className="h-full bg-primary"
        style={{ width: '0%' }}
      />
    </div>
  );
};
